import { httpRequest } from './http';

const BACKEND_BASE = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:3001/api/v1';

export const authApi = {
  me: () => httpRequest(BACKEND_BASE, '/auth/me', { method: 'GET' }),
  login: (email, password) => httpRequest(BACKEND_BASE, '/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  register: (email, name, password) => httpRequest(BACKEND_BASE, '/auth/register', { method: 'POST', body: JSON.stringify({ email, name, password }) }),
  logout: () => httpRequest(BACKEND_BASE, '/auth/logout', { method: 'POST' }),
};

export default authApi;
